export const decodeJWT = (token: string): any => {
	try {
		const cleanToken = token.replace('Bearer ', '');

		const parts = cleanToken.split('.');

		if (parts.length !== 3) {
			throw new Error('Token JWT inválido');
		}

		const payload = parts[1];

		const paddedPayload = payload + '='.repeat((4 - (payload.length % 4)) % 4);

		const decodedPayload = atob(paddedPayload);

		return JSON.parse(decodedPayload);
	} catch (error) {
		console.error('Erro ao decodificar JWT:', error);
		return null;
	}
};

export const getTransportadoraId = (token: string): string | null => {
	const payload = decodeJWT(token);

	if (!payload) {
		return null;
	}

	return payload['UboiWeb.TransportadoraId'] || null;
};

export const hasOutsystemIntegrationAccess = (token: string): boolean => {
	const payload = decodeJWT(token);

	if (!payload || !payload.unique_name || !Array.isArray(payload.unique_name)) {
		return false;
	}

	const allowedUniqueNames = [
		'14668237043',
		'39308158855',
		'44295072877',
		'53468203888',
		'02916265009116',
		'46458829884',
		'38396818800',
		'44295072877',
		'31349110875',
		'40365071846',
		'63958236120',
		'48899153892',
		'03123438171',
		'09713706994',
		'01560783176',
		'48568416888',
		'48984131881',
		'24163083863',
		'53468203888',
	];

	return payload.unique_name.some((uniqueName: string) => allowedUniqueNames.includes(uniqueName));
};
